/**
 * Zimbabwean dollar.
 */
export var ZWL = {
  code: 'ZWL',
  base: 10,
  exponent: 2
};